export default __webpack_public_path__ + "static/si-summit-banner-e2e16a4b1ab5a81966ac422111f824ce.jpg";